import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_PAYEE_ENGAGEMENTS_LIST } from "../keys";
import { getPayeeEngagement } from "../../../services/payeeEngagement/getPayeeEngagement";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";

export const useQueryPayeeEngagement = (
  payeeEngagementId: string,
  config?: WSQueryConfig<IPayeeEngagementResponse, WSServiceError>
) => {
  return useWSQuery<IPayeeEngagementResponse, WSServiceError>(
    [QUERY_PAYEE_ENGAGEMENTS_LIST, payeeEngagementId],
    async () => {
      return await getPayeeEngagement(payeeEngagementId);
    },
    {
      ...config
    }
  );
};
